import React from 'react';
import { UIPicture } from '../basic';
import { UIWindowModal } from '../modals';
import { UIVoiceoverBtn } from '../composite';
import { useLang } from '../../../_LangContext';
import Utils from '../../../_Utils';

const ModalStampcardPopup = ({ isOpen, onClose, data }) =>
{
	const { lang, getText, isVoiceoverEnabled } = useLang();

	if (!data) return null;

	// Extract title and description from markdown content
	const getContentParts = (markdown) =>
	{
		if (!markdown) return { title: '', description: '' };

		const lines = markdown.split('\n');
		let title = '';
		let description = '';

		// Find title (starts with ###)
		const titleLine = lines.find(line => line.startsWith('###'));
		if (titleLine)
		{
			title = titleLine.replace('### ', '');
			// Get description (everything after the title and following empty line)
			description = lines
				.slice(lines.indexOf(titleLine) + 2)
				.join('\n')
				.trim();
		}

		return { title, description };
	};

	const { title, description } = getContentParts(data.description);

	const handleVOStateChange = (eventName) =>
	{
		// Handle voiceover state changes if needed
	};

	return (
		<UIWindowModal className="stampcard-popup" isOpen={isOpen} onClose={onClose}>
			<div className="modal-container">
				<div className="modal-container-inner">
					<div className="modal-title">
						{getText('mashimo')}
					</div>

					{data.img && (
						<UIPicture
							src={data.img}
							alt={data.name}
							className="item-image"
						/>
					)}

					<div className="block item-title">
						<div className="trivia-title">{title}</div>
						<div className="item-name">{data.name}</div>
					</div>

					{data.description_audio && isVoiceoverEnabled() && (
						<UIVoiceoverBtn
							lang={lang}
							filename={data.description_audio}
							onStateChange={handleVOStateChange}
							className="popup"
						/>
					)}

					<div className="description" dangerouslySetInnerHTML={{ __html: Utils.markdownToHtml(description) }} />
				</div>
			</div>
		</UIWindowModal>
	);
};

export default ModalStampcardPopup;